import React from 'react'
import SliderImage from '../../Slider/SliderImage'

const HeroSection: React.FC = () => {
  return (
    <>
      <SliderImage />
    </>
  )
}

export default HeroSection
